import React from 'react'
import images from '../../../Asset/Img/img';
import "./QualityAssurance.css";
import data from '../../../Data/data';
import { useTranslation } from 'react-i18next';

function QualityAssurance() {

  const { t } = useTranslation();

  return (
    <div className='qualityassurance-container'>
      <div className="qualityassurance-content">

        <div className='qualityassurance-header'>
          <h3>{t('nav_quality_qualitassurance')}</h3>
        </div>
        <div className='pro-text-promotion'>
          <div className='iso-container'>
            <h3>{t('quality-assurance-header-text')}</h3>
            <a href={data.hpcData} target="_blank" download={true} rel="noreferrer"><img src={images.qualityIsoIcon} alt="ISO-icon" title="PDF DOSYASI İNDİR" /></a>
          </div>

          <p>{t('quality-assurance-bold-header')}</p>
          <li>{t('quality-assurance-li-text-one')}</li>
          <li>{t('quality-assurance-li-text-two')}</li>
          <li>{t('quality-assurance-li-text-three')}</li>
          <li>{t('quality-assurance-li-text-four')}</li>
          <li>{t('quality-assurance-li-text-five')}</li>
          <li>{t('quality-assurance-li-text-six')}</li>
          <li>{t('quality-assurance-li-text-seven')}</li>
          <li>{t('quality-assurance-li-text-eight')}</li>
          <li>{t('quality-assurance-li-text-nine')}</li>
          <p>{t('quality-assurance-p-text')}</p>
        </div>

        <div className='qualityassurance-header-bottom'>

        </div>

      </div>
    </div>
  )
}

export default QualityAssurance
